// extracted by mini-css-extract-plugin
export default {"container":"Category_container__4LViR","content":"Category_content__WQsU+"};